import axios from "axios";
import { useState } from "react";
import { BASE_URL } from '../config';

const DepartmentAdd = ({ onDepartmentAdded }) => {
  const [depertmentname, setDepertmentname] = useState("");
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token"); // Token from localStorage

    try {
      const response = await axios.post(
        `${BASE_URL}/department`,
        {
          depertmentname: depertmentname,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Department created successfully!");
      setDepertmentname("");
      setErrors({});
      if (onDepartmentAdded) onDepartmentAdded(); // 🔁 notify parent to reload list
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
      } else if (error.response?.status === 401) {
        alert("Unauthorized. Please login again.");
        // Optionally redirect
      } else {
        alert("Something went wrong!");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group row mb-2">
        <label className="col-lg-3 col-form-label text-lg-end">
          Department Name
        </label>
        <div className="col-lg-9">
          <input
            type="text"
            name="depertmentname"
            value={depertmentname}
            onChange={(e) => setDepertmentname(e.target.value)}
            className={`form-control ${
              errors.depertmentname ? "is-invalid" : ""
            }`}
          />
          {errors.depertmentname && (
            <div className="invalid-feedback">
              {errors.depertmentname[0]}
            </div>
          )}
        </div>
      </div>

      <div className="text-center p-2 m-2">
        <button type="submit" className="btn btn-primary">
          <i className="fas fa-check"></i> Submit
        </button>
      </div>
    </form>
  );
};

export default DepartmentAdd;
